import { createContext } from 'react';

const alertDialogContext: any = createContext('');

export default alertDialogContext;
